import * as React from "react";

const SvgIcnAdd = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                d="M16.51 12.573h-3.937v3.937a.573.573 0 11-1.147 0v-3.937H7.49a.573.573 0 110-1.147h3.937V7.49a.573.573 0 011.147 0v3.937h3.936a.573.573 0 010 1.147z"
                fill="currentColor"
            />
        </g>
    </svg>
);

export default SvgIcnAdd;
